import React from 'react';
import PropTypes from 'prop-types';
import LogInForm from '@/shared/components/account/loginForm/LogInForm';
import {
  AccountCard,
  AccountContent,
  AccountHead,
  AccountLogo,
  AccountLogoAccent,
  AccountTitle,
  AccountWrap,
} from '@/shared/components/account/AccountElements';
import AgentForm from '../../../shared/components/account/AddAgent/AgentForm';
import { SignInLogo } from '../../Layout/components/topbar/BasicTopbarComponents';


const auth0Icon = `${process.env.PUBLIC_URL}/img/auth0.svg`;

const Form = () => {
  const handleSubmit = (value) => {
    console.log(JSON.stringify(value, null, 2));
  };
  return (
    <AccountWrap>
      <AccountContent>
        {/* <AccountCard> */}
        <AccountHead>
          {/* <SignInLogo to="/online_marketing_dashboard" /> */}
          {/* <h4 className="subhead" /> */}
        </AccountHead>
        <AgentForm form="/agent_form" onSubmit={handleSubmit} />
        {/* <AccountOr>
          <p>Or Easily Using</p>
        </AccountOr> */}
        {/* Add other social login buttons as needed */}
          
        {/* </AccountCard> */}
      </AccountContent>
    </AccountWrap>
    );
};

// LogIn.propTypes = {
//   changeIsOpenModalFireBase: PropTypes.func.isRequired,
// };

export default Form;
